import { render } from "./GreenLayer.svg?vue&type=template&id=3c84ac5a"
const script = {}
script.render = render

export default script